"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RESET_ACCOUNT_PIN_QUERY = "\n    mutation resetPin($pinType: PinType!) {\n        resetPin(pinType: $pinType)\n    }\n";
exports.default = RESET_ACCOUNT_PIN_QUERY;
//# sourceMappingURL=resetAccountPin.js.map